import { useState, useEffect } from 'react';
import { Newspaper, Calendar, ArrowRight } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const NEWS_FEATURED_IMG = "https://customer-assets.emergentagent.com/job_protect-florida-now/artifacts/7keydyqs_AA0236B5-0B4E-4CCE-918A-E847C2152446%20-%20Copy.png";

export default function News() {
  const [articles, setArticles] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    axios.get(`${API}/news`).then(r => setArticles(r.data)).catch(() => {});
  }, []);

  if (selected) {
    return (
      <div className="pt-16 min-h-screen bg-white" data-testid="news-article-detail">
        <div className="max-w-3xl mx-auto px-6 lg:px-8 py-24">
          <button onClick={() => setSelected(null)} className="text-sm text-navy font-body hover:text-gold mb-6 inline-block" data-testid="back-to-news">&larr; Back to News</button>
          <p className="text-xs tracking-[0.2em] uppercase font-bold text-gold font-body mb-3">
            <Calendar className="w-3 h-3 inline mr-1" />
            {new Date(selected.created_at).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>
          <h1 className="text-3xl sm:text-4xl font-heading font-bold text-navy mb-6">{selected.title}</h1>
          <p className="text-sm text-gray-500 font-body mb-8">By {selected.author || 'Safe Florida'}</p>
          <div className="prose prose-lg font-body text-gray-700 leading-relaxed whitespace-pre-wrap">
            {selected.content}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="pt-16" data-testid="news-page">
      <section className="bg-navy py-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <p className="text-xs tracking-[0.2em] uppercase font-bold text-gold font-body mb-3">Latest Updates</p>
          <h1 className="text-4xl sm:text-5xl font-heading font-bold text-white mb-4">News & Updates</h1>
          <p className="text-lg text-white/80 font-body">Stay informed about Safe Florida's latest initiatives and community impact.</p>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          {articles.length === 0 ? (
            <div className="text-center py-16">
              <Newspaper className="w-12 h-12 text-gray-300 mx-auto mb-4" />
              <p className="text-gray-500 font-body">No articles yet. Check back soon!</p>
            </div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {articles.map((article, i) => (
                <button key={article.id} onClick={() => setSelected(article)}
                  className="text-left border border-gray-200 rounded-lg overflow-hidden card-hover" data-testid={`news-card-${article.id}`}>
                  <div className="h-40 bg-navy/5 flex items-center justify-center overflow-hidden">
                    {article.image_url ? (
                      <img src={article.image_url} alt={article.title} className="w-full h-full object-cover" />
                    ) : i === 0 ? (
                      <img src={NEWS_FEATURED_IMG} alt="Safe Florida News" className="w-full h-full object-cover" />
                    ) : (
                      <Newspaper className="w-10 h-10 text-navy/20" />
                    )}
                  </div>
                  <div className="p-5">
                    <p className="text-xs text-gold font-body font-bold mb-2">
                      {new Date(article.created_at).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}
                    </p>
                    <h3 className="font-heading font-bold text-navy text-lg mb-2 line-clamp-2">{article.title}</h3>
                    <p className="text-sm text-gray-600 font-body line-clamp-3 mb-3">{article.summary || article.content?.slice(0, 150) + '...'}</p>
                    <span className="text-sm text-gold font-body font-medium inline-flex items-center gap-1">Read More <ArrowRight className="w-3 h-3" /></span>
                  </div>
                </button>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
